import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ButtonComponent } from '../button/button.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { IUser, UserService } from '../../services/user/user.service';
import { filter, Subject, takeUntil } from 'rxjs';
import { EventMessage, EventType, InteractionStatus, RedirectRequest } from '@azure/msal-browser';
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-session',
    imports: [ButtonComponent, FaIconComponent, NgIf],
    templateUrl: './session.component.html',
    styleUrl: './session.component.scss'
})
export class SessionComponent implements OnInit, OnDestroy {
    private readonly _destroying$ = new Subject<void>();

    public get user() {
        return this.userService.user;
    }

    public isProcessing = false;
    loginDisplay = false;

    setLoginDisplay() {
        this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
    }

    checkAndSetActiveAccount() {
        let activeAccount = this.authService.instance.getActiveAccount();

        if (
            !activeAccount &&
            this.authService.instance.getAllAccounts().length > 0
        ) {
            let accounts = this.authService.instance.getAllAccounts();
            this.authService.instance.setActiveAccount(accounts[0]);
        }
    }

    loginRedirect() {
        if (this.msalGuardConfig.authRequest) {
            this.authService.loginRedirect({
                ...this.msalGuardConfig.authRequest,
            } as RedirectRequest);
        } else {
            this.authService.loginRedirect();
        }
    }

    public logout() {
        this.authService.logoutRedirect();
    }

    constructor(
        @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
        private authService: MsalService,
        private msalBroadcastService: MsalBroadcastService,
        private userService: UserService
    ) { }

    ngOnInit(): void {
        this.authService.handleRedirectObservable().subscribe();

        this.setLoginDisplay();
        this.authService.instance.enableAccountStorageEvents();
        this.msalBroadcastService.msalSubject$
            .pipe(
                filter(
                    (msg: EventMessage) =>
                        msg.eventType === EventType.ACCOUNT_ADDED ||
                        msg.eventType === EventType.ACCOUNT_REMOVED
                )
            )
            .subscribe((result: EventMessage) => {
                if (this.authService.instance.getAllAccounts().length === 0) {
                    window.location.pathname = '/';
                } else {
                    this.setLoginDisplay();
                }
            });

        this.msalBroadcastService.inProgress$
            .pipe(
                filter(
                    (status: InteractionStatus) => status === InteractionStatus.None
                ),
                takeUntil(this._destroying$)
            )
            .subscribe(() => {
                this.setLoginDisplay();
                this.checkAndSetActiveAccount();

                if (this.loginDisplay) {
                    this.isProcessing = true;
                    this.userService.getSelf().subscribe(user => {
                        this.userService.user = user;
                        this.isProcessing = false;
                    });
                }
            });
    }

    ngOnDestroy(): void {
        this._destroying$.next(undefined);
        this._destroying$.complete();
    }
}
